import styled from 'styled-components';

// Constants
import { SCREEN } from '../../assets/styles/constants';

export const Image = styled.img`
	display: block;
	width: 100%;
	${props => props.maxWidth && `max-width:${props.maxWidth}px`};
	${props => props.tail && 'margin-bottom: -6.1%;'};
`;

export const SocialMedia = styled.img`
	background: transparent;
	color: white;
	font-size: 20px;
	width: 100%;
`;

export const SectionImage = styled.img`
	margin: 0 auto;
	max-width: 700px;
	max-height: 500px;
	width: 100%;
	object-fit: contain;
	display: block;
`;

export const BirdHolder = styled.div`
	top: 0px;
	right: 0px;
	position: absolute;
	${props => (props.messageSend ? 'animation: birdMove 2s linear;' : '')};
	opacity: 0;
	z-index: -1;

	@keyframes birdMove {
		10%   {transform: rotate(-5deg) translate(calc(0px + 5vw), -20px) rotate(5deg); opacity: 1;}
		20%   {transform: rotate(1deg) translate(calc(0px + 10vw), -20px) rotate(-1deg); opacity: 1;}

		30%   {transform: rotate(-3deg) translate(calc(0px + 15vw), -20px) rotate(3deg); opacity: 1;}
		40%   {transform: rotate(1deg) translate(calc(0px + 20vw), -20px) rotate(-1deg); opacity: 1;}

		50%   {transform: rotate(-3deg) translate(calc(0px + 25vw), -20px) rotate(3deg); opacity: 1;}
		60%   {transform: rotate(1deg) translate(calc(0px + 30vw), -20px) rotate(-1deg); opacity: 1;}

		70%   {transform: rotate(-3deg) translate(calc(0px + 35vw), -20px) rotate(3deg); opacity: 1;}
		80%   {transform: rotate(1deg) translate(calc(0px + 40vw), -20px) rotate(-1deg); opacity: 1;}

		90%   {transform: rotate(-3deg) translate(calc(0px + 45vw), -20px) rotate(3deg); opacity: 1;}
		100%   {transform: rotate(1deg) translate(calc(0px + 50vw), -20px) rotate(-1deg); opacity: 1;}
	}

	img {
		max-width: 150px;
	}
`;

export const PhoneHolder = styled.div`
	position: absolute;
	bottom: 320px;
	width: 30vw;

	${SCREEN.MEDIUM} {
		display: none;
	}

	${SCREEN.LARGE} {
		width: 20%;

	}

	img {
		width: 100%;
	}
`;

export const FeaturedShowcaseImage = styled.img`
	width: 150px;
	align-self: flex-start;

	${SCREEN.SMALL} {
		width: 70px;
	}
`;

export const FeaturedShowcaseLogo = styled.img`
	max-height: 30px;
	max-width: 150px;
`;

export const ShowcaseGameBackgroundImage = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	height: 250px;

	${SCREEN.MEDIUM} {
		display: none;
	}
`;
